<template>
    <div class="regularPost">
        <Heading
            :h="3"
            size="m">
            {{ title }}
        </Heading>
        <Contributor
            :slug="post.author.slug"
            :avatar="post.author.avatar"
            :name="post.author.name"
            :uploadTime="post.uploadTime">
            {{ siteContent.publishedBy }}
        </Contributor>
        <p class="summary">
            {{ summary }}
        </p>
    </div>
</template>

<script>
    import Contributor from '@/components/entry/Contributor'

    export default {
        name: 'RegularPost',
        components: {
            Contributor
        },
        props: {
            post: {
                type: Object,
                required: true
            }
        },
        computed: {
            title() {
                if(this.preferences.language === 'hu' && this.post.title.hu) {
                    return this.post.title.hu
                } else {
                    return this.post.title.en
                }
            },
            summary() {
                if(this.preferences.language === 'hu' && this.post.summary.hu) {
                    return this.post.summary.hu
                } else {
                    return this.post.summary.en
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../scss/variables';

    .coverWrapper {
        height: 20rem;
        border-radius: 0.75rem;
        overflow: hidden;
    }

    .cover {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
        transition: $transition-eio-20;
    }

    .h3 {
        margin: 0 0 1.5rem 0;
    }

    .summary {
        font-size: 1rem;
        margin-bottom: 0;
    }

    .footer {
        padding: 1.5rem;
    }

</style>